import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { useModal } from '../../../../../hooks/use-modal';
import { linkIDs } from '../../../../../services/link-service/links';
import { useProvidersGridContext } from '../../providers-grid-context';
import { DefaultCarrierSharingModal } from '../default-carrier-sharing-modal';
import { DocSection } from '../doc-section';
import messages from './messages';
import styles from './styles.module.less';

export const CarrierSharingDescription = () => {
  const { calculateCounters, carrierSharing } = useProvidersGridContext();

  const { close, isOpen, open } = useModal();

  if (!calculateCounters()) {
    return null;
  }

  return (
    <>
      {isOpen && <DefaultCarrierSharingModal isOpen={isOpen} onClose={close} />}
      <DocSection
        articleId={linkIDs.CarrierSharing}
        childrenBeforeDoc={
          <Button className={styles['default-cs-btn']} disabled={carrierSharing.isLoading} onClick={open} theme={THEME_CONSTANTS.tertiary}>
            <FormattedMessage {...messages.defaultCarrierSharingButton} />
          </Button>
        }
        descriptionMessage={messages.defaultCarrierSharingDescription}
      />
    </>
  );
};
